var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"i-checks block m-b-md",class:[_vm.classes, {'disabled': _vm.disabled}]},[_c('input',{attrs:{"name":_vm.name,"disabled":_vm.disabled,"type":"radio"},domProps:{"checked":_vm.value === _vm.model,"value":_vm.val},on:{"change":e => _vm.$emit('input', e.target.value)}}),_c('i'),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }